<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>产销统计</span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="用户类型" prop="level">
            <el-select
              v-model.number="queryParams.level"
              placeholder="请选择类型"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            >
              <el-option
                v-for="(item, index) in userType"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="奖励类型" prop="type">
            <el-select
              v-model.number="queryParams.type"
              placeholder="请选择类型"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            >
              <el-option
                v-for="(item, index) in rewardType"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
            width="130px"
          />
          <el-table-column v-for="(item, index) in tableKeys" :key="index" align="center" :label="item.t">
            <el-table-column
              :prop="item.k1"
              align="center"
              label="总数"
              :formatter="numFormatter2"
              width="200"
            />
            <el-table-column
              :prop="item.k2"
              align="center"
              label="人均"
              :formatter="numFormatter2"
              width="200"
            />
          </el-table-column>
        </el-table>

        <!--        产销统计-->
        <el-row :gutter="12">
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <OutputsStats ref="data" :legend="legend1" :keys="keys1" />
          </el-col>
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <OutputsStats ref="data2" :legend="legend" :keys="keys" :title="'人均产出消耗'" />
          </el-col>
        </el-row>
      </el-card>

      <!--      产出统计-->
      <el-card v-if="echartStat.includes(queryParams.type)">
        <SpinsConsumeTotal ref="total" :params="queryParams" :typ="'+'" :title="'产出占比'" :rid="ridType" :reward="rewardType" />
      </el-card>

      <el-card v-if="echartStat.includes(queryParams.type)">
        <SpinsConsumeTotal ref="total1" :params="queryParams" :typ="'-'" :title="'消耗占比'" :rid="ridType" :reward="rewardType" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { exportStatData, getSpinsConsumeV2 } from '@/api/statistics/user_remain'
import SpinsConsumeTotal from '@/views/config/spins-consume/compents/total.vue'
import { getRewardType } from '@/api/config/slot'
import { getRidTypeList } from '@/api/config/reward-record'
import { getCacheQuery, getLastDates, getUserConsumeLabel, scientificFormat, setCacheQuery } from '@/utils'
import OutputsStats from '@/views/config/spins-consume/compents/outputs.vue'

export default {
  name: 'SpinsConsume',
  components: {
    OutputsStats,
    SpinsConsumeTotal
    // SpinsConsumeAct
  },
  data() {
    return {
      tableKeys: [
        { t: '累计结余', t2: '人均结余', k1: 'stock_spin', k2: 'stock_spin_avg' },
        { t: '累计产出', t2: '人均产出', k1: 'grant_spin', k2: 'grant_spin_avg' },
        { t: '累计消耗', t2: '人均消耗', k1: 'cost_spin', k2: 'cost_spin_avg' },
        { t: '收集活动产出', t2: '收集活动人均产出', k1: 'collect_spin', k2: 'collect_spin_avg' },
        { t: '锦标赛产出', t2: '锦标赛人均产出', k1: 'rank_spin', k2: 'rank_spin_avg' },
        { t: '集齐卡组产出', t2: '集齐卡组人均产出', k1: 'collect_card', k2: 'collect_card_avg' },
        { t: '连环礼包产出', t2: '连环礼包人均产出', k1: 'serial_pack', k2: 'serial_pack_avg' },
        { t: '体力大师产出', t2: '体力大师人均产出', k1: 'spins_master', k2: 'spins_master_avg' },
        { t: '金币老虎机产出', t2: '金币老虎机产出', k1: 'treasure', k2: 'treasure_avg' },
        { t: '跃进活动产出', t2: '跃进活动人均产出', k1: 'leap_frog', k2: 'leap_frog_avg' },
        { t: 'vip产出', t2: 'vip人均产出', k1: 'vip', k2: 'vip_avg' }
      ],
      // keys: ['stock_spin_avg', 'grant_spin_avg', 'cost_spin_avg', 'collect_spin_avg', 'rank_spin_avg', 'serial_pack_avg', 'spins_master_avg', 'treasure_avg', 'vip_avg'],
      // legend: ['人均结余', '人均产出', '人均消耗', '收集活动人均产出', '锦标赛人均产出', '莲华礼包人均产出', '体力大师人均产出', '金币老虎机人均产出', 'vip人均产出'],
      keys: [],
      keys1: [],
      legend: [],
      legend1: [],
      userType: [],
      echartStat: [14, 15, 22, 65, 69, 70],
      rewardType: [],
      rewardId: [14, 15, 22],
      ridType: {},
      country: [],
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: '',
        type: 14,
        level: 0
      },
      loading: false,
      options: [],
      tableData: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  created() {
    this.userType = getUserConsumeLabel()
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
    this.getRidTypeData()
    this.getRewardTypeData()
    this.getTables(undefined)
    this.keys = []
    this.legend = []
    for (const i in this.tableKeys) {
      const val = this.tableKeys[i]
      this.keys1.push(val.k1)
      this.keys.push(val.k2)
      this.legend1.push(val.t)
      this.legend.push(val.t2)
    }
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.loading = true
      this.getTables({})
    },
    getTables(event) {
      this.tableData = []
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getSpinsConsumeV2(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.loading = false
        if (res.code === 200) {
          if (res.data.data.length > 0) {
            this.tableData = res.data.data
            if (!this.tableData) {
              this.tableData = []
            }
            this.$refs.data.refresh(res.data.data)
            this.$refs.data2.refresh(res.data.data)
            if (this.echartStat.includes(this.queryParams.type)) {
              this.$refs.total.getTables()
              this.$refs.total1.getTables()
            }
          }
          // this.queryParams.startDate = res.data.req.startDate
          // this.queryParams.endDate = res.data.req.endDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const id = parseInt(i)
            if (this.rewardId.includes(id)) {
              this.rewardType.push({ 'label': res.data[i], 'value': id })
            }
          }
        }
      })
    },
    getRidTypeData() {
      getRidTypeList().then(res => {
        if (res.code === 200) {
          this.ridType = res.data
          // for (const i in res.data) {
          //   this.ridType.push({ 'label': res.data[i], 'value': parseInt(i) })
          // }
        }
      })
    },
    exportData(typ) {
      exportStatData({ startDate: this.queryParams.startDate, endDate: this.queryParams.endDate, type: typ }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter2(col, row, val) {
      return scientificFormat(val)
    }
  }
}
</script>

<style scoped>
.mtop20{
  margin-top: 15px;
}
</style>
